import * as React from 'react';
import { v4 } from 'uuid';

import { CheckboxContain } from './Checkbox/CheckboxContain';
import { CheckboxBackground } from './Checkbox/CheckboxBackground';
import { CheckboxInput } from './Checkbox/CheckboxInput';
import { CheckboxLabel } from './Checkbox/CheckboxLabel';
import { ICheckboxProps } from './Checkbox/common';

export { ICheckboxProps };

export default class Checkbox extends React.PureComponent<React.InputHTMLAttributes<HTMLInputElement> & ICheckboxProps> {
  private readonly _id: string = v4();

  public render () {
    const { children, id, alert, ...restProps } = this.props;

    return (
      <CheckboxContain>
        <CheckboxInput
          {...restProps}
          id={this._id}
          data-id={id}
          aria-checked={restProps.checked}
          type='Checkbox'
          alert={alert}
        />
        <CheckboxLabel
          alert={alert}
          htmlFor={this._id}
          data-id={id}
        >
          {children}
        </CheckboxLabel>
        <CheckboxBackground alert={alert} />
      </CheckboxContain>
    );
  }
}
